<div class="dialog-container">
    <h4 mat-dialog-title>{{data.title}}</h4>
    <ng-container *ngIf="data.access === 'department'">
        <div mat-dialog-content class="dialog-content text-muted">
            <div class="spinner-container" *ngIf="isLoading">
                <mat-spinner></mat-spinner>
                <span>Loading please wait...</span>
            </div>
            <div *ngIf="!isLoading">
                <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
                    <ng-container matColumnDef="number">
                        <th class="text-primary" mat-header-cell *matHeaderCellDef>#</th>
                        <td mat-cell *matCellDef="let element; let i = index">
                            {{ (paginator1.pageIndex * paginator1.pageSize) + i + 1 }}
                        </td>
                    </ng-container>
    
                    <ng-container matColumnDef="department">
                        <th class="text-primary" mat-header-cell *matHeaderCellDef mat-sort-header>Department</th>
                        <td mat-cell *matCellDef="let element">{{ element.name }}</td>
                    </ng-container>
    
                    <ng-container matColumnDef="action">
                        <th class="text-primary" mat-header-cell *matHeaderCellDef mat-sort-header>Action</th>
                        <td mat-cell *matCellDef="let element; let i = index">
                            <i class="material-icons" *ngIf="!loading[i]" matTooltip="Delete department"
                                (click)="deleteDepartment(element.id, i)">delete</i>
                            <div class="spinner-border" *ngIf="loading[i]" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </td>
                    </ng-container>
    
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
                <div class="w-100 p-2 text-center" *ngIf="dataSource?.data?.length === 0">No data Found</div>
                <mat-paginator #paginator1 [pageSizeOptions]="[5]" showFirstLastButtons></mat-paginator>
            </div>
        </div>
        <div mat-dialog-actions class="dialog-actions d-flex align-items-center justify-content-end">
            <button mat-button class="cancel-button" (click)="onNoClick()">{{data.cancelText}}</button>
        </div>
    </ng-container>
    <ng-container *ngIf="data.access === 'branch'">
        <div mat-dialog-content class="dialog-content text-muted">
            <div class="spinner-container" *ngIf="isLoading">
                <mat-spinner></mat-spinner>
                <span>Loading please wait...</span>
            </div>
            <div *ngIf="!isLoading">
                <table mat-table [dataSource]="dataSource2" matSort class="mat-elevation-z8">
                    <ng-container matColumnDef="number">
                        <th class="text-primary" mat-header-cell *matHeaderCellDef>#</th>
                        <td mat-cell *matCellDef="let element; let i = index">
                            {{ (paginator2.pageIndex * paginator2.pageSize) + i + 1 }}
                        </td>
                    </ng-container>
    
                    <ng-container matColumnDef="department">
                        <th class="text-primary" mat-header-cell *matHeaderCellDef mat-sort-header>Branch</th>
                        <td mat-cell *matCellDef="let element">{{ element.name }}</td>
                    </ng-container>
    
                    <ng-container matColumnDef="action">
                        <th class="text-primary" mat-header-cell *matHeaderCellDef mat-sort-header>Action</th>
                        <td mat-cell *matCellDef="let element; let i = index">
                            <i class="material-icons" *ngIf="!loading[i]" matTooltip="Delete branch"
                                (click)="deleteBranch(element.id, i)">delete</i>
                            <div class="spinner-border" *ngIf="loading[i]" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </td>
                    </ng-container>
    
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
                <div class="w-100 p-2 text-center" *ngIf="dataSource2?.data?.length === 0">No data Found</div>
                <mat-paginator #paginator2 [pageSizeOptions]="[5]" showFirstLastButtons></mat-paginator>
            </div>
        </div>
        <div mat-dialog-actions class="dialog-actions d-flex align-items-center justify-content-end">
            <button mat-button class="cancel-button" (click)="onNoClick()">{{data.cancelText}}</button>
        </div>
    </ng-container>
    <ng-container *ngIf="data.access === 'client'">
        <div mat-dialog-content class="dialog-content text-muted">
            <div class="spinner-container" *ngIf="isLoading">
                <mat-spinner></mat-spinner>
                <span>Loading please wait...</span>
            </div>
            <div *ngIf="!isLoading">
                <table mat-table [dataSource]="dataSource3" matSort class="mat-elevation-z8">
                    <ng-container matColumnDef="number">
                        <th class="text-primary" mat-header-cell *matHeaderCellDef>#</th>
                        <td mat-cell *matCellDef="let element; let i = index">
                            {{ (paginator3.pageIndex * paginator3.pageSize) + i + 1 }}
                        </td>
                    </ng-container>
    
                    <ng-container matColumnDef="department">
                        <th class="text-primary" mat-header-cell *matHeaderCellDef mat-sort-header>Client</th>
                        <td mat-cell *matCellDef="let element">{{ element.name }}</td>
                    </ng-container>
    
                    <ng-container matColumnDef="action">
                        <th class="text-primary" mat-header-cell *matHeaderCellDef mat-sort-header>Action</th>
                        <td mat-cell *matCellDef="let element; let i = index">
                            <i class="material-icons" *ngIf="!loading[i]" matTooltip="Delete client"
                                (click)="deleteClient(element.id, i)">delete</i>
                            <div class="spinner-border" *ngIf="loading[i]" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </td>
                    </ng-container>
    
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
                <div class="w-100 p-2 text-center" *ngIf="dataSource3?.data?.length === 0">No data Found</div>
                <mat-paginator #paginator3 [pageSizeOptions]="[5]" showFirstLastButtons></mat-paginator>
            </div>
        </div>
        <div mat-dialog-actions class="dialog-actions d-flex align-items-center justify-content-end">
            <button mat-button class="cancel-button" (click)="onNoClick()">{{data.cancelText}}</button>
        </div>
    </ng-container>
</div>